import { ClienteAnaliseMercadoProjecaoClassificacaoSearch } from './cliente-analise-mercado-projecao-classificacao-search';

/** Utilizada para salvar as projeções de vendas das classificações nas análises de mercado de clientes */
export class ClienteAnaliseMercadoProjecaoClassificacaoSave {
    idClienteAnaliseMercadoClassificacao: number;
    idGrupoClassificacao: number;
    classificacoesSlug: number[];

    // Quantidade Projetada
    quantidadeProjetada: number;
    // Peso Projetado
    pesoProjetado: number;
    // Valor Projetado
    valorProjetado: number;

    /** Projeção salva do lançamento da classificação quando informado que deve carregá-la após salvá-la */
    projecao: ClienteAnaliseMercadoProjecaoClassificacaoSearch;

    constructor(idClienteAnaliseMercadoClassificacao: number = null, idGrupoClassificacao: number = null, classificacoesSlug: number[] = null, quantidadeProjetada: number = null, pesoProjetado: number = null, valorProjetado: number = null) {
        this.idClienteAnaliseMercadoClassificacao = idClienteAnaliseMercadoClassificacao;
        this.idGrupoClassificacao = idGrupoClassificacao;
        this.classificacoesSlug = classificacoesSlug;

        this.quantidadeProjetada = quantidadeProjetada;
        this.pesoProjetado = pesoProjetado;
        this.valorProjetado = valorProjetado;
    }
}
